// index.tsx
// copyright (c) 2023-present Henrik Bechmann, Toronto, All rights reserved

import React, {lazy, Suspense} from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { ChakraProvider, extendTheme } from '@chakra-ui/react'
import Loading from './system/Loading'

const AppProvider = lazy(() => import('./system/AppProvider'))

import scaffold from './system/routescaffold'

const router = createBrowserRouter(scaffold)

const container = document.getElementById('root')

const theme = extendTheme({
    colors: {
      brand: {
        100: "#f7fafc",
        // etc
        900: "#1a202c",
      },
    },
  })

if (container) {
    const root = createRoot(container)

    root.render(
        // <React.StrictMode>
            <ChakraProvider theme={theme}>
                <Suspense fallback={<Loading />}>
                    <AppProvider>
                        <RouterProvider router={router} />
                    </AppProvider>
                </Suspense>
            </ChakraProvider>
        // </React.StrictMode>
    )
} else {
    document.body.innerHTML = '<div>Failed to find the root element</div>'
}
